module.exports = __webpack_public_path__ + "media/images/pc/visit_reservations_enpou/flow_02-5efc60551b87ddc62a886f77a9e334e2.jpg";